<div class="stack-chart">
  <div class="stack-chart-area" [id]="chartId"></div>

  <div class="stack-legend" *ngIf="legend.length">
    <div class="legend-item" *ngFor="let item of legend">
      <span class="legend-swatch" [style.background]="item.color"></span>
      <span class="legend-name" [title]="item.name">{{ item.name }}</span>
    </div>
  </div>
</div>
